import { render, staticRenderFns } from "./additionalChargesList.vue?vue&type=template&id=ec7f81ca&scoped=true&"
import script from "./additionalChargesList.vue?vue&type=script&lang=js&"
export * from "./additionalChargesList.vue?vue&type=script&lang=js&"
import style0 from "./additionalChargesList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./additionalChargesList.vue?vue&type=style&index=1&id=ec7f81ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7f81ca",
  null
  
)

export default component.exports